module.exports = __webpack_public_path__ + "img/chrbutton_zh.a12632fe.png";